export default __webpack_public_path__ + "static/media/banking-details.50e11da2.svg";